{
	"send": "Envoyer"
}
